import { render, staticRenderFns } from "./StaffAccount.vue?vue&type=template&id=0a1376eb&scoped=true"
import script from "./StaffAccount.vue?vue&type=script&lang=js"
export * from "./StaffAccount.vue?vue&type=script&lang=js"
import style0 from "./StaffAccount.vue?vue&type=style&index=0&id=0a1376eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1376eb",
  null
  
)

export default component.exports